<template>
    <text-input
      :label="label"
      :prop="prop"
      :required="required"
      type="number"
      v-model="form"
      :step="step"
      :decimals="0"
      :size="size"
      align-input="right"
      :min="min"
      :max="max"
      :prefix="prefix"
      :suffix="suffix"
      :is-prefix-icon="isPrefixIcon"
      :is-suffix-icon="isSuffixIcon"
      @input="v = parseFloat($event)"
     :disabled="disabled"
     :no-form="noForm"
     :placeholder="placeholder"
     @change="updated">
   </text-input>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'integer-input',

  mixins: [NumberMixins],

  props: {
    // XOL-67 (decision 185), additive: a cleared field emits null instead of 0 (Antenna AGL, where 0 is a value). Default false: every other caller unchanged.
    emptyIsNull: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    value: {
//      type: Number,
      required: true
    },
    prop: {
      type: String,
      default: null
    },
    decimals: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },

    size: {
      type: String,
      default: 'default'
    },

    prefix: {
      type: String,
      default: null
    },

    suffix: {
      type: String,
      default: null
    },

    isPrefixIcon: {
      type: Boolean,
      default: false
    },

    isSuffixIcon: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      // XOL-67 (decision 185): with `emptyIsNull` a cleared field is null, not the 0 Math.round('') makes, so a real 0 and "no value" differ.
      if (this.emptyIsNull && (value === '' || value === null || value === undefined)) {
        this.form = null
        this.$emit('input', null)
        this.$emit('change', null)
        return
      }

      // Math.round takes one arg; trailing 0 was always ignored (Bug H cleanup)
      this.form = Math.round(value)
      this.$emit('input', Math.round(value))
      this.$emit('change', Math.round(value))
    }
  },

  watch: {
    value: function (val) {
      this.form = val
    }
  },


  data () {
    return {
      form: this.value
    }
  }
}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>
